import { fromJS } from 'immutable';
import setIn from 'transmute/setIn';
import { EXCLUDED_COLUMNS, CRM_TO_BUILDER_PROPERTY } from './constants';
export const getDimensionColumn = (columns, dimensionColumnProperty) => {
  if (dimensionColumnProperty) {
    return dimensionColumnProperty;
  }
  const dimensionColumn = columns.find(column => !column.name.includes('name') && !column.name.includes('subject') && !column.name.includes('email') && !column.name.includes('phone') && !column.name.includes('date'));
  return dimensionColumn && `${dimensionColumn.name}`;
};
export const normalizeCrmColumns = (dataType, columns) => {
  const normalizedColumns = fromJS(columns).map(column => column.get('name')).map(name => CRM_TO_BUILDER_PROPERTY[dataType] && CRM_TO_BUILDER_PROPERTY[dataType][name] || name)
  // A view might have amount AND amount_in_home_currency
  .filter(columnName => !EXCLUDED_COLUMNS.includes(columnName));
  const columnsHasCount = normalizedColumns.includes('count');
  if (!columnsHasCount) {
    return normalizedColumns.push('count');
  }
  return normalizedColumns;
};
export const setDataColumns = setIn(['displayParams', 'dataColumns']);